'use client'

import posthog from 'posthog-js'
import { getPosthogAdditionalDetails } from '@/lib/posthog/get-posthog-additional-details'

export function posthogAdditionalDetailsKey(userId: string) {
  return ['posthog-additionalDetails', userId] as const
}

/**
 * Loads server-signed Support identity and applies it on the SDK before tickets
 * are fetched, so lookup uses the user id instead of the browser session.
 */
export async function applyPosthogSupportIdentity() {
  const details = await getPosthogAdditionalDetails()
  if (details.identityHash && details.distinctId) {
    posthog.setIdentity(details.distinctId, details.identityHash)
  }
  return details
}
